import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../../components/common/InputComp/Input";
import TabComp from "../../../../components/TabsComp/TabComp";
import Btn from "../../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../../utils/asyncStatus";
import { primaryColor } from "../../../../utils/themeColors";
import {
  addProductStyleAsync,
  addProductSeasonYearAsync,
  deleteProductSeasonYearAsync,
  editProductStyleAsync,
  editProductSeasonYearAsync,
  getProductStyleAsync,
  getProductSeasonYearAsync,
} from "../../../../store/services/productInfoServices";
const SeasonYear = () => {
  const dispatch = useDispatch();
  const {
    getProductSeasonYearStatus,
    getProductSeasonYearError,
    getProductSeasonYearData,
    addProductSeasonYearStatus,
    addProductSeasonYearData,
    addProductSeasonYearError,

    editProductSeasonYearStatus,
    editProductSeasonYearError,
    editProductSeasonYearData,

    deleteProductSeasonYearData,
    deleteProductSeasonYearStatus,
    deleteProductSeasonYearError,
  } = useSelector((state) => state.product);

  useEffect(() => {
    dispatch(getProductSeasonYearAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getProductSeasonYearData?.length
    ? getProductSeasonYearData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedSeasonYear, setSelectedSeasonYear] = useState();
  const [addSeasonYearMode, setAddSeasonYearMode] = useState(false);
  const [addSeasonYearData, setAddSeasonYearData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedSeasonYear", selectedSeasonYear);
  // console.log("editData", editData);
  useEffect(() => {
    if (addProductSeasonYearStatus === asyncStatus.SUCCEEDED) {
      setAddSeasonYearMode(false);
      setSaveDisabled(true);
      setAddSeasonYearData();
    }
  }, [, addProductSeasonYearStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteProductSeasonYearAsync(selectedSeasonYear?.season_year_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteProductSeasonYearStatus === asyncStatus.SUCCEEDED) {
      setOpen(false);
      setSelectedSeasonYear();
    }
  }, [, deleteProductSeasonYearStatus]);
  useEffect(() => {
    if (editProductSeasonYearStatus === asyncStatus.SUCCEEDED) {
      setSelectedSeasonYear();
      setEditMode(false);
    }
  }, [, editProductSeasonYearStatus]);
console.log("getProductSeasonYearData",getProductSeasonYearData,editProductSeasonYearData);
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this SeasonYear?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Season Year"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Season Year Name
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddSeasonYearMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addSeasonYearMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addSeasonYearMode || !selectedSeasonYear}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddSeasonYearMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addSeasonYearMode || !selectedSeasonYear}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addProductSeasonYearStatus === asyncStatus.LOADING ||
                  editProductSeasonYearStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addSeasonYearData) {
                    dispatch(addProductSeasonYearAsync(addSeasonYearData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedSeasonYear, ...editData };
                    delete a.id;
                    dispatch(editProductSeasonYearAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={"500px"} width={"100%"}>
              <TableComp
                columns={[
                  { field: "season_year_id", headerName: "ID", flex: true },
                  {
                    field: "season_year",
                    headerName: "Season Year Name",
                    flex: true,
                  },
                ]}
                onRowClick={(e) => {
                  setSelectedSeasonYear(e?.row);
                }}
                rows={formattedData}
                loading={
                  getProductSeasonYearStatus === asyncStatus.IDLE ||
                  getProductSeasonYearStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addSeasonYearMode ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "Season Year:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddSeasonYearData({
                            ...addSeasonYearData,
                            season_year: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddSeasonYearData({
                            ...addSeasonYearData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedSeasonYear ? (
              <InputWithBtnLayoutComp
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedSeasonYear?.season_year_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "SeasonYear:",
                    comp: (
                      <InputComp
                        key={selectedSeasonYear?.season_year_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            season_year: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedSeasonYear?.season_year}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={editData?.is_active}
                        disabled={!editMode}
                        defaultValue={
                          selectedSeasonYear?.is_active ? true : false
                        }
                        defaultChecked={
                          selectedSeasonYear?.is_active ? true : false
                        }
                        checked={selectedSeasonYear?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (
              <Typography>Select any season year</Typography>
            )}

            <Stack>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {getProductSeasonYearError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {addProductSeasonYearError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {editProductSeasonYearError}
              </Typography>
              <Typography sx={{ fontSize: 14, color: "red" }}>
                {deleteProductSeasonYearError}
              </Typography>
            </Stack>
            <Stack my={2}>
              <TabComp
                tabs={[
                  // {
                  //   name: "Companies",
                  //   content: (
                  //     <Stack height={400} width={"100%"}>
                  //       <TableComp
                  //         columns={[
                  //           {
                  //             field: "companyId",
                  //             headerName: "Company ID",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "companyName",
                  //             headerName: "Company Name",
                  //             flex: true,
                  //           },
                  //           {
                  //             field: "action",
                  //             headerName: "Action",
                  //             flex: true,
                  //           },
                  //         ]}
                  //         //   onRowClick={(e) => {
                  //         //     setSelectedSeasonYear(e?.row);
                  //         //   }}
                  //         rows={[]}
                  //         //   loading={
                  //         //     getProductStyleStatus === asyncStatus.IDLE ||
                  //         //     getProductStyleStatus === asyncStatus.LOADING
                  //         //   }
                  //       />
                  //     </Stack>
                  //   ),
                  // },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedSeasonYear(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default SeasonYear;
